import { render, staticRenderFns } from "./ShowHDRLcdCalibration2DXYScatterPlot.vue?vue&type=template&id=125c8515"
import script from "./ShowHDRLcdCalibration2DXYScatterPlot.vue?vue&type=script&lang=js"
export * from "./ShowHDRLcdCalibration2DXYScatterPlot.vue?vue&type=script&lang=js"
import style0 from "./ShowHDRLcdCalibration2DXYScatterPlot.vue?vue&type=style&index=0&id=125c8515&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports